import moment from "moment";
import constants from "../../config/constants";

const $inject = ['$location', '$scope', '$timeout', '$routeParams', '$http', 'dataService', 'dataSourceService', 'microApiService'];

const lbaGridCtrl = function ($location, $scope, $timeout, $routeParams, $http, dataService, dataSourceService, microApiService) {
  const vm = this;

  vm.dataService = dataService;
  vm.ready = false;
  vm.canAdd = vm.settings.hasOwnProperty('gridAdd');
  vm.filters = undefined;
  if (dataService.backGridFilter != null && dataService.backGridFilter[vm.settings.displayName]) {
    vm.filters = dataService.backGridFilter[vm.settings.displayName]
  }
  var page = 1;
  if (dataService.backGridPage != null && dataService.backGridPage[vm.settings.displayName]) {
    page = dataService.backGridPage[vm.settings.displayName]
  }
  $scope.$watch("vm.filters", function () {
    if (vm.filters === '') {
      vm.filters = undefined;
    }
  });
  vm.onClick = onClick;
  vm.addNew = addNew;
  vm.getObjectPropertyValue = getObjectPropertyValue;
  vm.getValueToDisplay = getValueToDisplay;
  vm.isShowingDisabled = false;
  vm.toggleDisabledData = toggleDisabledData;
  vm.isRestEndpoint = vm.settings.isRestEndpoint || false;

  vm.sortableOptions = {
    disabled: !vm.settings.sortable,
    stop: function (e, ui) {
      var originalGridData = getGridData();
      updateGridData(originalGridData, vm.resource.rows);
      loadData();
    }
  };

  loadData(true);

  function processMicroService(res) {
    vm.dataService.data.items = res.data;
    vm.resource = {
      header: vm.settings.gridCols,
      rows: vm.dataService.data.items,
      pagination: {
        page
      }
    };

    vm.ready = true;
  }

  function loadData(getData) {
    if (vm.settings.microService) {
      dataSourceService.dataSource = constants.DATA_SOURCES.AUTH_ZERO;
      microApiService.get({ endpoint: vm.settings.endpoint, cb: processMicroService });
    } else {
      if (vm.settings.endpoint && getData) {
        dataSourceService.dataSource = constants.DATA_SOURCES.ODATA;
        dataService.data.activeItem = undefined;
        let ODataArgs = vm.settings.ODataArgs || '';
        if (vm.settings.ODataArgs && $routeParams) {
          for (const [key, value] of Object.entries($routeParams)) {
            if (ODataArgs.indexOf(`:${key}`) !== -1) {
              ODataArgs = ODataArgs.replace(`:${key}`, value);
            }
          }
        }
        dataService.get(vm.settings.endpoint + ODataArgs, null, vm.isRestEndpoint).then((data) => {
          vm.dataService.data.items = data;
          vm.globalData = data;

          const dataToShow = filterDisabledData(vm.isShowingDisabled);
          addDataToGrid(vm.settings.gridCols, dataToShow, page);
        });
      }
      else {
        const rowData = prepData(getGridData());
        vm.globalData = rowData;

        const dataToShow = filterDisabledData(vm.isShowingDisabled);
        addDataToGrid(vm.settings.gridCols, dataToShow, page);
      }
    }
  }

  function getGridData() {
    if ($routeParams && Object.keys($routeParams).length != 0 && vm.settings.dataAt) {
      const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
      var gridData = _.get(dataService.data.activeItem, dataLookUp);
      return gridData;
    }
    else {
      return dataService.data.items;
    }
  }

  function updateGridData(originalGridData, newGridData) {
    for (var i = 0; i < originalGridData.length; i++) {
      if (newGridData[i]) {
        originalGridData[i] = newGridData[i];
      }
    }
  }

  function filterDisabledData(isDisabledShowing) {
    let unfilteredData = vm.globalData;
    let propertyName = vm.settings.disableProperty || "Disabled";

    if (!!vm.settings.canFilterDisabled) {
      if (!!!isDisabledShowing) {

        let filteredData = [];

        for (let i = 0; i < unfilteredData.length; i++) {
          let canPushUnfilteredItem = !!vm.settings.filterUsingEnabled ? unfilteredData[i][propertyName] : !unfilteredData[i][propertyName];
          if (canPushUnfilteredItem) {
            filteredData.push(unfilteredData[i]);
          }
        }

        return filteredData;
      }
    }

    return unfilteredData;
  }

  function toggleDisabledData() {
    vm.isShowingDisabled = !vm.isShowingDisabled;
    const dataToShow = filterDisabledData(vm.isShowingDisabled);
    addDataToGrid(vm.settings.gridCols, dataToShow, page);
  }

  function addDataToGrid(headers, data, page) {

    vm.resource = {
      header: headers,
      rows: data,
      pagination: {
        page
      }
    };

    vm.ready = true;
  }

  function onClick(data, copyItem, copyResource) {
    if (vm.settings.disableRowClick) {
      
      if (dataService && dataService.data && data && vm.settings.setActiveItemSubItem) {
        dataService.data.activeItemSubItem = data;
      }
      else if (dataService && dataService.data && data) {
        dataService.data.activeItem = data;
      }
      return;
    }

    if (copyItem) {
      vm.ready = false;

      $timeout(() => {
        const clonedData = angular.copy(data);
        delete clonedData.Id;
        if (!(clonedData[vm.settings.gridCols[0].key] instanceof Array) && !vm.settings.copyWithoutCopyText) {
          clonedData[vm.settings.gridCols[0].key] += ' COPY';
        }
        vm.resource.rows.push(clonedData);
        const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
        const activeItem = prepData(_.get(dataService.data.activeItem, dataLookUp));
        activeItem.push(clonedData);
        _.set(dataService.data.activeItem, dataLookUp, activeItem);
        vm.copyMode = false;
        vm.ready = true;
      }, 0);

      return
    }

    if (copyResource) {
      let copyResourceEndpoint = vm.settings.copyResourceEndpoint || vm.settings.endpoint;
      let nameFieldName = vm.settings.nameFieldName || 'Name';

      dataService.get(copyResourceEndpoint, data.Id).then((data) => {
        const duplicate = data;

        if (!vm.settings.copyWithoutCopyText) {
          duplicate[nameFieldName] = duplicate[nameFieldName] + ' COPY';
        }

        delete duplicate.Id;

        vm.dataService.post(copyResourceEndpoint, duplicate, true).then(data => {
          updatePath(data)
        });
      });

      return
    }

    let rowIndex = 0;

    // JLF: LOBT-700: undersore's findIndex was removed as it returned false positives
    _.find(vm.resource.rows, (item, index) => {
      if (item === data) rowIndex = index;
    });

    // JLF: LOBT-773: also caching the current page and filter on the grid as well
    dataService.backPath = $location.$$path;
    if (!dataService.backGridFilter)
      dataService.backGridFilter = {};
    dataService.backGridFilter[vm.settings.displayName] = vm.filters;
    if (!dataService.backGridPage)
      dataService.backGridPage = {};
    dataService.backGridPage[vm.settings.displayName] = vm.resource.pagination.page || 1;

    updatePath(data, rowIndex);
  }

  function addNew() {
    dataService.backPath = $location.$$path;

    if (vm.settings.gridAdd) {
      $location.path($location.$$path + '/add');
    } else {
      dataService.addNewMode = true;
      // Create backup of complete data structure before adding empty item
      dataService.addNewBackup = angular.copy(dataService.data);

      if (vm.resource.rows) {
        vm.resource.rows.push({});
      } else {
        vm.resource.rows = [{}];
      }
      updatePath({}, vm.resource.rows.length - 1);
    }
  }

  function updatePath(data, index) {

    let displayNamePathReady = vm.settings.gridAdd || vm.settings.routeWithId ? '' : vm.settings.displayName.replace(/\s+/g, '-').toLowerCase();

    if (vm.settings.pathSwitcher) {
      displayNamePathReady = vm.settings.pathSwitcher(data);
    }

    const appendToPath = displayNamePathReady + (vm.settings.gridAdd || vm.settings.routeWithId ? data.Id : '/' + index);
    $location.path($location.$$path + '/' + appendToPath);
  }

  function prepData(data) {
    if (data) {
      return data.map(item => {
        return item;
      })
    }
  }

  function getObjectPropertyValue(obj, path, defaultValue = null, formater = null) {
    const val = _.get(obj, path, defaultValue);
    if (val && formater === "dateLocal") {
      return moment.utc(val).local().format("M/D/Y HH:mm Z");
    }
    return val;
  }
  function getValueToDisplay(val){
  if(val) return val;
  if(val==="0" || val===0) return "0";
  return "-"
  }
};


lbaGridCtrl.$inject = $inject;

export default lbaGridCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaGrid/lbaGridCtrl.js